import { createContext } from 'react';

import ManagerSegmentStore from './ManagerSegmentStore';

const ManagerSegmentStoreContext = createContext<{
  store: ManagerSegmentStore | null;
}>({
  store: null
});

const ManagerSegmentStoreProvider = ManagerSegmentStoreContext.Provider;

export { ManagerSegmentStoreContext, ManagerSegmentStoreProvider };
